import React from 'react'

export const SearchResultNewClient = ({ onSelect }) => {
  return (
    <div className='row search-footer' role='row'>
      <div role='cell' className='col-12 mt-1 mb-5 d-flex flex-row align-items-center'>
        <button type='button' className='btn btn-secondary' onClick={onSelect}>
          This is a new person
        </button>
      </div>
    </div>
  )
}
